import {
  Address,
  CustomerInfo,
  UpdateCustomerAddressChallenge,
  UpdateCustomerAddressesResult,
  UpdateCustomerAddressesResultTypenames,
  UpdateCustomerAddressResult,
  UpdateCustomerAddressResultTypenames,
} from '@varo/graphql-schema-types';
import { router } from 'expo-router';
import {
  PersonalDetailsItemDetails,
  PersonalDetailsItems,
} from 'features/personalDetails/screens/PersonalDetails.helpers';
import { VXLComponentId } from 'shared/renderer/types';

export const getMutationErrorMessage = (
  updateResult?: UpdateCustomerAddressResult | null,
  updateMultipleResult?: UpdateCustomerAddressesResult | null,
) => {
  let isError = false;
  let isSuccessful = false;
  let isDeclined = false;
  let errorMessage: string | undefined;
  let isChallenged = false;
  let challengeParams: UpdateCustomerAddressChallenge[] | undefined;

  switch (updateResult?.__typename) {
    case UpdateCustomerAddressResultTypenames.UpdateCustomerAddressSuccess:
      isSuccessful = true;
      break;
    case UpdateCustomerAddressResultTypenames.UpdateCustomerAddressError:
    case UpdateCustomerAddressResultTypenames.UpdateCustomerAddressThrottled:
      isError = true;
      errorMessage = updateResult.message;
      break;
  }
  switch (updateMultipleResult?.__typename) {
    case UpdateCustomerAddressesResultTypenames.UpdateCustomerAddressesSuccess:
      if (
        updateMultipleResult.challenges &&
        updateMultipleResult.challenges.length > 0
      ) {
        isChallenged = true;
        challengeParams = updateMultipleResult.challenges;
      } else {
        isSuccessful = true;
      }
      break;
    case UpdateCustomerAddressesResultTypenames.UpdateCustomerAddressesError:
      isError = true;
      errorMessage = updateMultipleResult.message;
      break;
    case UpdateCustomerAddressesResultTypenames.UpdateCustomerAddressesDeclined:
      isDeclined = true;
      errorMessage = updateMultipleResult.declineMessage;
      break;
  }

  return {
    isError,
    isSuccessful,
    isDeclined,
    errorMessage,
    isChallenged,
    challengeParams,
  };
};

export const buildHomeMailingAddressPersonalDetailItems = (
  customerInfo: CustomerInfo | null,
  isHomeAndMailingAddressFeatureEnabled: boolean,
): Partial<PersonalDetailsItems> => {
  const homeAddress = customerInfo?.address ?? ({} as Address);
  const mailingAddress = customerInfo?.mailingAddress ?? ({} as Address);

  const fullAddress = Object.values(homeAddress)
    .filter((item) => item)
    .join(', ');

  const fullMailingAddress = Object.values(mailingAddress)
    .filter((item) => item)
    .join(', ');

  const mainAddressSectionAnalyticsId =
    !customerInfo?.isMailingAddressDifferentThanResidential &&
    isHomeAndMailingAddressFeatureEnabled
      ? 'changeHomeAndMailingAddressClicked'
      : 'changeHomeAddressClicked';

  var homeMailingAddressItems: Partial<PersonalDetailsItems> = {};

  const homeAddressListItem: PersonalDetailsItemDetails = {
    label: fullAddress,
    analyticsId: mainAddressSectionAnalyticsId,
    trailingAccessory: {
      id: 1,
      name: VXLComponentId.ICON,
      props: {
        iconKey: 'EDIT',
      },
    },
    onPress: () =>
      router.push(
        `/myvaro/personal-details/change-address${isHomeAndMailingAddressFeatureEnabled ? '?analyticsKey=changeAddress' : ''}`,
      ),
  } as PersonalDetailsItemDetails;

  if (
    !customerInfo?.isMailingAddressDifferentThanResidential &&
    isHomeAndMailingAddressFeatureEnabled
  ) {
    homeMailingAddressItems.homeAndMailingAddress = homeAddressListItem;
  } else {
    homeMailingAddressItems.homeAddress = homeAddressListItem;
  }

  if (
    customerInfo?.isMailingAddressDifferentThanResidential &&
    isHomeAndMailingAddressFeatureEnabled
  ) {
    homeMailingAddressItems.mailingAddress = {
      label: fullMailingAddress,
      analyticsId: 'changeMailingAddressClicked',
      trailingAccessory: {
        id: 1,
        name: VXLComponentId.ICON,
        props: {
          iconKey: 'EDIT',
        },
      },
      onPress: () =>
        router.push(
          '/myvaro/personal-details/change-mailing-address?analyticsKey=changeMailingAddress',
        ),
    };
  }

  return homeMailingAddressItems;
};
